import React from "react";

import Table from "../../../common/Table";

import lbl from "../../../../data/Labels.json";

const ExpenseCard = ({ data }) => {
  const _data = {
    data: data?.expenses || [],
    summary: data?.expensesSummary || [],
  };

  const columns = [
    { path: "id", label: "شماره" },

    {
      path: "name",
      label: "حوزه های مصرف",
    },
    {
      path: "payable",
      label: "بودجه",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقی مانده",
    },
  ];

  return (
    <div className="finance-wrapper-box">
      <h5 className="title">{lbl.ExpenseAccounts}</h5>
      <div className="table">
        <Table data={_data} columns={columns} />
      </div>
    </div>
  );
};

export default ExpenseCard;
